'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChainId } from '@morpho-org/blue-sdk';
import { useState } from 'react';
import { type OptionSelectMultipleNetwork, SelectMultipleNetwork } from '@/components/common/SelectMultipleNetwork';
import DashboardCard from '@/components/EarnPage/EarnDashboard/DashboardCard/DashboardCard';
import { ChainConfig } from '@/config';
import { DashboardClass } from '@/contexts/Dashboard/Dashboard.context';
import { useViewedAccountAddress } from '@/hooks/useViewedAccountAddress';
import { useDashboardEarnPositions } from '../hooks/useDashboardEarnPositions';
import DashboardHeroApyCard from './DashboardHeroApyCard';
import DashboardHeroDepositsChart from './DashboardHeroDepositsChart';
const allNetworkOptions: OptionSelectMultipleNetwork[] = ChainConfig.INTERFACE_CHAINS.map(chain => ({
  label: chain.chain.name,
  // oxlint-disable-next-line typescript/consistent-type-assertions
  value: chain.chain.id as ChainId,
  tag: chain.isNew ? 'New' : undefined
}));
const DashboardHero = () => {
  const $ = _c(21);
  const {
    address
  } = useViewedAccountAddress();
  const {
    earnPositions,
    loading,
    isError
  } = useDashboardEarnPositions(address);
  let chainsWithPositions;
  let hasPositions;
  let t0;
  if ($[0] !== address || $[1] !== earnPositions || $[2] !== isError || $[3] !== loading) {
    let t1;
    bb0: {
      if (!address || loading || isError) {
        t1 = null;
        break bb0;
      }
      t1 = new Set(earnPositions.map(_temp));
    }
    chainsWithPositions = t1;
    hasPositions = chainsWithPositions !== null && chainsWithPositions.size > 0;
    t0 = hasPositions ? allNetworkOptions.filter(opt => chainsWithPositions.has(opt.value)) : allNetworkOptions;
    $[0] = address;
    $[1] = earnPositions;
    $[2] = isError;
    $[3] = loading;
    $[4] = chainsWithPositions;
    $[5] = hasPositions;
    $[6] = t0;
  } else {
    chainsWithPositions = $[4];
    hasPositions = $[5];
    t0 = $[6];
  }
  const networkOptions = t0;
  let t1;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const [selectedChains, setSelectedChains] = useState(t1);
  const [isAllSelected, setIsAllSelected] = useState(true);
  const chainIds = isAllSelected ? ChainConfig.AVAILABLE_CHAIN_IDS : selectedChains;
  const t2 = chainsWithPositions !== null && !hasPositions;
  let t3;
  if ($[8] !== isAllSelected || $[9] !== networkOptions || $[10] !== selectedChains || $[11] !== t2) {
    t3 = <div onClick={_temp2}><SelectMultipleNetwork options={networkOptions} values={selectedChains} isAllSelected={isAllSelected} setIsAllSelected={setIsAllSelected} onChange={setSelectedChains} disabled={t2} triggerClassName={DashboardClass.PREVENT_DASHBOARD_CARD_HOVER_CLASS} /></div>;
    $[8] = isAllSelected;
    $[9] = networkOptions;
    $[10] = selectedChains;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const chainSelector = t3;
  let t4;
  if ($[13] !== chainIds || $[14] !== chainSelector) {
    t4 = <DashboardHeroDepositsChart chainIds={chainIds} titleExtra={chainSelector} />;
    $[13] = chainIds;
    $[14] = chainSelector;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== chainIds) {
    t5 = <DashboardHeroApyCard chainIds={chainIds} />;
    $[16] = chainIds;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t4 || $[19] !== t5) {
    t6 = <DashboardCard chartMyDepositsSlot={t4} earnApyCardSlot={t5} />;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
};
export default DashboardHero;
function _temp(position) {
  return position.vault.chainId as ChainId;
}
function _temp2(e) {
  return e.stopPropagation();
}